import { useCallback, useRef } from "react";

import { Box } from "@similarweb/ui-components/foundations";

import { WidgetContainer } from "app/components/React/WidgetContainer/WidgetContainer";
import { useSubtitleFilters } from "app/custom-hooks/useSubtitleFilters";
import { PdfExportService } from "app/services/PdfExportService";
import { useTranslation } from "pro-features/components/WithTranslation";

import { useDemographicsAgeDistributionData } from "../../hooks/useDemographicsAgeDistributionData";

import { AgeDistributionBarChart } from "./AgeDistributionBarChart";

export const IndustryAnalysisDemographicsAgeDistributionChart = () => {
    const t = useTranslation();
    const subtitleFilters = useSubtitleFilters("date");
    const chartRef = useRef(null);

    const { data: ageData, isLoading, isError } = useDemographicsAgeDistributionData();

    const handleExportChartPng = useCallback(() => {
        if (chartRef) {
            const styleHTML = PdfExportService.getStylesheetsForPng();

            const offSetX = 0;
            const offSetY = 50;
            return PdfExportService.downloadHtmlPngFedService(
                styleHTML + chartRef.current.outerHTML,
                "Age Distribution",
                chartRef.current.offsetWidth + offSetX,
                chartRef.current.offsetHeight + offSetY,
            );
        }
    }, [chartRef]);

    return (
        <Box
            ref={chartRef}
            width="100%"
        >
            <WidgetContainer
                withBorder
                minWidth="100%"
                subtitleFilters={subtitleFilters}
                title={t("category.demographics.age.chart.title")}
                onDownloadClick={handleExportChartPng}
                downloadProps={{ PNG: true }}
                loaderHeight={240}
                loaderWidth="100%"
                isLoading={isLoading}
                noData={isError ? !isLoading : null}
                noDataTitle={t("category.demographics.chart.no.data.title")}
                noDataSubtitle={t("category.demographics.age.chart.no.data")}
                automationId="industry-analysis-demographics-age-distribution-graph"
            >
                {ageData ? (
                    <AgeDistributionBarChart
                        age18To24={ageData.age18To24}
                        age25To34={ageData.age25To34}
                        age35To44={ageData.age35To44}
                        age45To54={ageData.age45To54}
                        age55To64={ageData.age55To64}
                        age65Plus={ageData.age65Plus}
                    />
                ) : null}
            </WidgetContainer>
        </Box>
    );
};
